import { Component, OnInit } from '@angular/core';
import { RoomchampionsState } from '../../@core/ngrx/roomchampions/roomchampions.state';
import { Store, select } from '@ngrx/store';
import * as fromRoomchampionsAction from 'src/app/@core/ngrx/roomchampions/roomchampions.actions';
import { Observable, of } from 'rxjs';
import { RankListResponseWrapper } from '../../api/models';
import { selectRoomchampionsByRoom } from '../../@core/ngrx/roomchampions/roomchampions.selectors';
import { isLoading } from '../../@core/ngrx/runningaction/running-action.selectors';
import { ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/@core/services/theme.service';

@Component({
  selector: 'app-roomchampions-page',
  templateUrl: './roomchampions-page.component.html',
  styleUrls: ['./roomchampions-page.component.scss'],
})
export class RoomChampionsPageComponent implements OnInit {
  roomchampions$: Observable<RankListResponseWrapper[]> = new Observable();
  loading$: Observable<boolean> = of(false);
  room?: string;
  defaultRoom: string = '';
  branch?: string;
  theme: string = '';

  constructor(
    private store: Store<RoomchampionsState>,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.room = this.activatedRoute.snapshot.url[2].path;
    this.branch = this.activatedRoute.snapshot.url[1].path;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['color']) {
        this.theme = params['color'];
      } else {
        this.theme = 'light';
      }
      this.themeService.setTheme(this.theme!);
    });

    this.theme === 'dark'
      ? document.body.classList.add('dark-theme')
      : document.body.classList.add('light-theme');

    this.store.dispatch(
      fromRoomchampionsAction.loadMany({
        room: this.room,
        nameSpace: this.branch,
      }),
    );

    this.roomchampions$ = this.store.pipe(
      select(selectRoomchampionsByRoom(this.room)),
    );

    this.loading$ = this.store.pipe(
      select(isLoading([fromRoomchampionsAction.loadMany])),
    );
  }
}
